/**
 * @fileoverview Agent definition for prose-expander-comparison-v2.
 *
 * This is a COMPOSITE agent that orchestrates:
 * 1. prose-expander-v2 × N: Run expansion in parallel with different models
 *
 * Used to compare expansion outputs across different AI models.
 *
 * @category writing.refinement
 * @type composite
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
export const definition: AppAgentDefinition = {
  id: 'prose-expander-comparison-v2',
  kind: 'composite',
  name: 'Prose Expander Comparison',
  description:
    'Runs prose-expander-v2 in parallel with different models to compare expansion outputs.',
  category: 'writing',
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'composite',
    addedIn: '2026-01',
    lastUpdated: '2026-01',
    taxonomyPath: 'writing.refinement.comparison',
    usedBy: ['RefinementComparisonPanel', 'use-comparison-refinements.ts'],
    composedOf: ['prose-expander-v2'],
    relatedAgents: ['chapter-drafter-comparison-v2', 'draft-refiner-comparison-v2', 'prose-shortener-comparison-v2'],
  },
};
